module.exports = __webpack_public_path__ + "static/service_bg@3x-c65ed5b94a46d89c846745a27e066320.png";